var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "#EB0A0A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.6956 11.2676L9.39089 1.50184C8.99052 0.827832 8.28341 0.425293 7.49943 0.425293C6.71544 0.425293 6.00833 0.827832 5.60796 1.50184C5.60494 1.50699 5.6024 1.51215 5.59938 1.5173L0.312346 11.2522C-0.0966087 11.9404 -0.104343 12.7669 0.291282 13.4628C0.687815 14.1592 1.40219 14.5746 2.20337 14.5746H12.7662C13.5674 14.5746 14.3111 14.1592 14.7076 13.4628C15.1032 12.7669 15.0955 11.9403 14.6956 11.2676ZM6.61964 4.89684C6.61964 4.41093 7.01354 4.01706 7.49943 4.01706C7.98534 4.01706 8.37921 4.41096 8.37921 4.89684V8.41601C8.37921 8.90187 7.98531 9.2958 7.49943 9.2958C7.01354 9.2958 6.61964 8.90184 6.61964 8.41601V4.89684ZM7.49943 12.815C6.77172 12.815 6.17972 12.223 6.17972 11.4953C6.17972 10.7676 6.77169 10.1756 7.49943 10.1756C8.22713 10.1756 8.8191 10.7676 8.8191 11.4953C8.81913 12.223 8.22716 12.815 7.49943 12.815Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.ad487d2abef01ea7b71b005e9ac63038.svg";
export { ForwardRef as ReactComponent };